<template>
  <div class="page-content">
    <div class="rule-detail">
      <el-breadcrumb separator="/" class="egl-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/rules' }">{{ $locale("sideMenu.performance.priceRuleTemplate") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ breadcrumbTitle }}</el-breadcrumb-item>
      </el-breadcrumb>

      <RuleTemplateForm
        v-bind:formObj="form"
        v-bind:groupList="groupList"
        v-bind:ticketTypeList="ticketTypeList"
        v-bind:couponTypeList="couponTypeList"
        v-bind:advanceCouponTypeList="advanceCouponTypeList"
        v-bind:versionList="versionList"
        ref="ruleTemplateForm"
      ></RuleTemplateForm>
    </div>

    <div class="detail-page-btn">
      <el-button class="egl-btn-white" @click="cancel_fn">{{ $locale("global.cancel") }}</el-button>
      <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm") }}</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RuleTemplateForm from "@/components/RuleTemplate/RuleTemplateForm.vue";
import { createRuleTemplate, updateRule, getCLCouponListService } from "@/helpers/service/api/ruleTemplate.js";
import {
  getGroup,
  getTicketType,
  getAdvanceCouponType,
  getVersionList,
  getOtherVersionList,
  getRuleTemplateDetail,
} from "@/assets/js/ruleTemplate.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import countDownAlert from "@/utils/countDownAlert";
import { rulesList } from "@/helpers/service/api/common.js";
import { getCouponTypeListForSelect } from "@/helpers/service/api/coupon";

export default {
  name: "ruleTemplateDetail",
  provide() {
    return {
      ruleList: () => this.provideRuleList,
      couponList: () => this.provideCouponList,
      setDisplayPlatform: this.setDisplayHandler,
      clCouponList: () => this.clCouponList
    };
  },
  data() {
    return {
      breadcrumbTitle: this.$locale("rules.createPriceRuleTemplate"),
      form: {},
      groupList: [],
      ticketTypeList: [],
      couponTypeList: [],
      advanceCouponTypeList: [],
      versionList: [],
      id: this.$route.params.id || "",
      provideRuleList: [],
      provideCouponList: [],
      clCouponList: [],
    };
  },
  computed: {
    ...mapState("app", {
      adminType: state => state.adminType,
      cinemaId: state => state.cinemaId,
    }),
  },
  methods: {
    cancel_fn() {
      this.$router.go(-1);
    },
    save_fn() {
      let formData = { ...this.$refs.ruleTemplateForm.saveForm() };
      let obj = { ...this.form };
      // console.log(formData, obj);
      if (formData.name) {
        obj = {
          ...obj,
          ...formData,
        };
        obj.ticketRule.generalTicket = {
          ...obj.ticketRule.generalTicket,
          comboItems: obj.ticketRule.generalTicket.comboItems.every(obj => !obj.type) ? null : obj.ticketRule.generalTicket.comboItems.filter(obj => obj.type).map(item => ({
            ...item,
            price: Number(item.price)
          }))
        };
        obj.ticketRule.otherTicket = obj.ticketRule.otherTicket
          .map(other => {
            if (other.comboItems) {
              return {
                ...other,
                comboItems: other.comboItems.every(obj => !obj.type) ? null : other.comboItems.filter(obj => obj.type).map(item => ({
                  ...item,
                  price: Number(item.price)
                }))
              };
            }
            return other;
          });
        obj.ticketRule.generalTicket.comboTicket = Boolean(obj.ticketRule.generalTicket.comboItems && obj.ticketRule.generalTicket.comboItems.length > 0);

        if (obj.ticketRule.otherTicket && obj.ticketRule.otherTicket.length > 0) {
          obj.ticketRule.otherTicket.forEach(other => {
            other.comboTicket = Boolean(other.comboItems && other.comboItems.length > 0);
          });
        }
        obj.ticketRule.webPreSaleRule = obj.ticketRule.webPreSaleRule.filter((item) => item.membershipRankId && item.timeAmount !== "");
        obj.ticketRule.posPreSaleRule = obj.ticketRule.posPreSaleRule.filter((item) => item.membershipRankId && item.timeAmount !== "");
        obj.ticketRule.scPreSaleRule = obj.ticketRule.scPreSaleRule.filter((item) => item.membershipRankId && item.timeAmount !== "");

        obj.ticketRule.webPreSaleRule.forEach((item) => {
          item.timeAmount = Number(item.timeAmount);
        })
        obj.ticketRule.posPreSaleRule.forEach((item) => {
          item.timeAmount = Number(item.timeAmount);
        })
        obj.ticketRule.scPreSaleRule.forEach((item) => {
          item.timeAmount = Number(item.timeAmount);
        })
        if (obj.id) {
          updateRule({ ticketRuleTemplateInfo: obj }).then(res => {
            if (res.success) {
              this.countDown(this.$locale("global.updateSuccessfully"));
            }
          }).catch(() => {});
        } else {
          obj.cinemaId = this.cinemaId;
          createRuleTemplate({ ticketRuleTemplateInfo: obj }).then(res => {
            if (res.success) {
              this.countDown(this.$locale("global.createSuccessfully"));
            }
          }).catch(() => {});
        }
      }
    },
    getData() {
      if (!this.cinemaId) {
        this.$emit("callCinema", "getData");
        return;
      }
      requestAll([
        getGroup(this.cinemaId),
        getTicketType(this.cinemaId),
        // getCouponType(this.cinemaId, this.adminType),
        getAdvanceCouponType(),
        getVersionList(this.cinemaId),
        getOtherVersionList(this.cinemaId),
        getRuleTemplateDetail(this.id)
      ]).then(res => {
        this.groupList = res[0].data;
        this.ticketTypeList = res[1].data.data;
        // this.couponTypeList = res[2].data.data;
        this.advanceCouponTypeList = res[2].data.data;
        this.versionList = [...res[3].data.data, ...res[4].data.data];

        if (this.id != "") {
          let form = res[5].data;
          if (!this.$_.isEmpty(form)) {
            let { generalTicket, otherTicket, versionPriceRule, seatPriceRule, unCouponTypeIds, webPreSaleRule} = form.ticketRule;
            let genIds = generalTicket.couponIds || [];
            let otherIds = [];
            otherTicket.forEach(item => {
              otherIds.push(...(item.couponIds || []));
            });
            let versionIds = [];
            versionPriceRule.forEach(item => {
              // unCouponTypeIds & couponId
              versionIds.push(...(item.unCouponTypeIds || []));
              if (item.couponId) {
                versionIds.push(item.couponId);
              }
            });
            let seatIds = [];
            seatPriceRule.forEach(item => {
              seatIds.push(...(item.unCouponTypeIds || []));
              if (item.couponId) {
                seatIds.push(item.couponId);
              }
            });
            if (genIds.length > 0 || otherIds.length > 0 || versionIds.length > 0 || seatIds.length > 0 || (unCouponTypeIds || []).length > 0) {
              getCouponTypeListForSelect({
                cinemaId: window.localStorage.getItem("cinemaId"),
                ids: [...genIds, ...otherIds, ...versionIds, ...seatIds, ...(unCouponTypeIds || [])],
                field: ["id", "name"],
                page: 0,
                pageSize: 9999
              }).then(res => {
                this.provideCouponList = this.$_.uniqBy([...res.data.data, ...this.provideCouponList], 'id');
              });
            }
          }
          // if (form.ticketRule.otherTicket.length == 0) {
          //   let originalForm = createFormObj();

          //   form.ticketRule.otherTicket.push(JSON.parse(JSON.stringify({ ...originalForm.ticketRule.generalTicket, default: false })));
          // }

          this.form = { ...form, ticketRule: {
            ...form.ticketRule,
            posPreSaleRule: !res[5].data.ticketRule.posPreSaleRule || res[5].data.ticketRule.posPreSaleRule.length === 0 ? [
              {
                membershipRankId: "",
                timeAmount: null,
                timeUnit: 'day',
              }
            ] : res[5].data.ticketRule.posPreSaleRule,
            webPreSaleRule: !res[5].data.ticketRule.webPreSaleRule || res[5].data.ticketRule.webPreSaleRule.length === 0 ? [
              {
                membershipRankId: "",
                timeAmount: null,
                timeUnit: 'day',
              }
            ] : res[5].data.ticketRule.webPreSaleRule,
            scPreSaleRule: !res[5].data.ticketRule.scPreSaleRule || res[5].data.ticketRule.scPreSaleRule.length === 0 ? [
              {
                membershipRankId: "",
                timeAmount: null,
                timeUnit: 'day',
              }
            ] : res[5].data.ticketRule.scPreSaleRule
          } };
        } else {
          getCouponTypeListForSelect({
            cinemaId: window.localStorage.getItem("cinemaId"),
            page: 0,
            pageSize: 20,
            field: ["id", "name"]
          }).then(res => {
            this.provideCouponList = res.data.data;
          });
        }
      });
    },
    countDown(str = this.$locale("global.createSuccessfully")) {
      countDownAlert({
        content: str,
        callback: () => {
          this.$router.go(-1);
        }
      });
    },
    setDisplayHandler(key, value) {
      if (this.$route.path.indexOf("create") > -1) {
        this.$refs.ruleTemplateForm.form.ticketRule[key] = value;
      } else {
        this.form.ticketRule[key] = value;
      }
    },
  },
  created() {
    getCouponTypeListForSelect({
      cinemaId: window.localStorage.getItem("cinemaId"),
      page: 0,
      pageSize: 20,
      field: ["id", "name"]
    }).then(res => {
      this.provideCouponList = res.data.data;
    });
    getCLCouponListService({ brandId: window.localStorage.getItem("brandId") }).then(res => {
      if (res.data && res.data.length > 0) {
        this.clCouponList = res.data;
      }
    });
    if(this.$route.path.indexOf("create") > -1) {
      rulesList({
        cinemaId: window.localStorage.getItem("cinemaId"),
        page: 0,
        pageSize: 9999
      }).then(res => {
        this.provideRuleList = res.data.data;
      });
    }
  },
  mounted() {
    this.getData();
  },
  components: {
    RuleTemplateForm,
  },
};
</script>
